<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 50 50"
  style="enable-background: new 0 0 50 50"
  xml:space="preserve"
  style="color: currentColor !important"
>
  <style type="text/css">
    .st0 {
      display: none;
    }
    .st1 {
      display: inline;
    }
    .st2 {
      fill: currentColor !important;
    }
    .st3 {
      display: inline;
      fill: #ffffff;
    }
    .st4 {
      display: inline;
      fill: currentColor !important;
    }
    .st5 {
      fill: #ffffff;
    }
    .st6 {
      display: inline;
      fill: currentColor !important;
    }
    .st7 {
      display: inline;
      fill: currentColor !important;
    }
    .st8 {
      display: inline;
      opacity: 0.6;
      fill: currentColor !important;
    }
    .st9 {
      display: inline;
      fill: currentColor !important;
    }
    .st10 {
      display: inline;
      fill: currentColor !important;
      stroke: currentColor !important;
      stroke-width: 0.5;
      stroke-miterlimit: 10;
    }
    .st11 {
      display: inline;
      fill: none;
      stroke: currentColor !important;
      stroke-width: 0.5;
      stroke-miterlimit: 10;
    }
    .st12 {
      fill: currentColor !important;
    }
    .st13 {
      fill: currentColor !important;
    }
  </style>
  <g class="st0">
    <g class="st1">
      <path
        class="st2"
        d="M3.5,22.9L22.9,3.5c1.2-1.2,3.1-1.2,4.2,0l19.3,19.3c1.2,1.2,1.2,3.1,0,4.2L27.1,46.5c-1.2,1.2-3.1,1.2-4.2,0
			L3.5,27.1C2.4,25.9,2.4,24.1,3.5,22.9z"
      />
    </g>
    <path
      class="st3"
      d="M34.6,21.3c-0.5,0-0.9,0.1-1.3,0.3l-4.8-4.8c0.2-0.4,0.3-0.9,0.3-1.3c0-2-1.7-3.7-3.7-3.7
		c-0.5,0-0.9,0.1-1.3,0.3l-4.6-4.6L17,9.4l4.6,4.6c-0.2,0.4-0.3,0.9-0.3,1.3c0,1.5,0.9,2.8,2.2,3.4v12.5c-1.3,0.6-2.2,1.9-2.2,3.4
		c0,2,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7c0-1.5-0.9-2.8-2.2-3.4V19l4.7,4.7c-0.2,0.4-0.3,0.9-0.3,1.3c0,2,1.7,3.7,3.7,3.7
		s3.7-1.7,3.7-3.7S36.7,21.3,34.6,21.3z"
    />
  </g>
  <g class="st0">
    <g class="st1">
      <path
        class="st2"
        d="M5.5,47.5h39c1.7,0,3-1.3,3-3v-39c0-1.7-1.3-3-3-3h-39c-1.7,0-3,1.3-3,3v39C2.5,46.2,3.8,47.5,5.5,47.5z"
      />
    </g>
    <path
      class="st3"
      d="M36.2,29.6v-9.2c0.6-0.2,1.1-0.6,1.5-1c2-2,2-5.1,0-7.1c-2-2-5.1-2-7.1,0c-2,2-2,5.1,0,7.1
		c0.5,0.5,1,0.8,1.5,1v9L20.4,17.6c0.7-1.8,0.3-3.9-1.1-5.4c-2-2-5.1-2-7.1,0c-2,2-2,5.1,0,7.1c1.4,1.4,3.6,1.8,5.4,1.1l11.9,11.9
		c-0.7,1.8-0.3,3.9,1.1,5.4c0.5,0.5,1,0.8,1.5,1v8.8h4v-8.8c0.6-0.2,1.1-0.6,1.5-1c2-2,2-5.1,0-7.1C37.3,30.2,36.7,29.8,36.2,29.6z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M45.2,24.3l-10-10c-0.2-0.2-0.5-0.2-0.7,0l-2.1,2.1c-0.2,0.2-0.2,0.5,0,0.7l5.9,5.9H13c-0.3,0-0.5,0.2-0.5,0.5
		v3c0,0.3,0.2,0.5,0.5,0.5h25.3l-5.9,5.9c-0.2,0.2-0.2,0.5,0,0.7l2.1,2.1c0.2,0.2,0.5,0.2,0.7,0l10-10
		C45.6,25.3,45.6,24.7,45.2,24.3z"
    />
    <path
      class="st4"
      d="M28.5,43.5h-15c-2.8,0-5-2.2-5-5v-27c0-2.8,2.2-5,5-5h15c0.6,0,1-0.4,1-1v-2c0-0.6-0.4-1-1-1h-15c-5,0-9,4-9,9
		v27c0,5,4,9,9,9h15c0.6,0,1-0.4,1-1v-2C29.5,43.9,29.1,43.5,28.5,43.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M33.6,16.8c-1.4,0-2.5-1.1-2.5-2.5V3.5c0-0.6-0.4-1-1-1H8c-1.6,0-3,1.3-3,3v39c0,1.7,1.4,3,3,3h34
		c1.7,0,3-1.3,3-3V16.8H33.6z"
    />
    <g class="st1">
      <rect
        x="23"
        y="24.2"
        transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 56.6579 6.6579)"
        class="st5"
        width="4"
        height="15"
      />
      <rect x="23" y="24.2" class="st5" width="4" height="15" />
    </g>
    <path
      class="st4"
      d="M34.1,3.2v10.6h10.1c0.3,0,0.4-0.3,0.2-0.5L34.7,3C34.5,2.8,34.1,3,34.1,3.2z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47.5,14c0-1.7-1.3-3-3-3H24.9c-0.5,0-1-0.2-1.4-0.6l-2.8-2.8C20.2,7.2,19.7,7,19.2,7H5.5c-1.7,0-3,1.3-3,3v30
		c0,1.6,1.3,3,3,3h39c1.7,0,3-1.3,3-3V14z"
    />
    <g class="st1">
      <path
        class="st5"
        d="M21.1,34.5l-3.5-3.5c-0.2-0.2-0.2-0.5,0-0.7l13.1-13.1c0.4-0.4,1-0.4,1.4,0l2.8,2.8c0.4,0.4,0.4,1,0,1.4
			L21.8,34.5C21.6,34.6,21.3,34.6,21.1,34.5z"
      />
      <path
        class="st5"
        d="M19.2,36.5l-3.7,0.7c-0.3,0.1-0.6-0.2-0.6-0.6l0.7-3.7c0.1-0.4,0.6-0.6,0.8-0.3l3.1,3.1
			C19.7,35.9,19.6,36.4,19.2,36.5z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M10,30.5l1.1-1.1l4.9-4.9c0.2-0.2,0.2-0.5,0-0.7l-1.4-1.4c-0.2-0.2-0.5-0.2-0.7,0L11.3,25h-4l-2.6-2.6
		c-0.2-0.2-0.5-0.2-0.7,0l-1.4,1.4c-0.2,0.2-0.2,0.5,0,0.7l4.9,4.9l1.1,1.1C9,30.9,9.7,30.9,10,30.5z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M33.2,21.7L30.8,23c-0.4-0.5-0.9-0.8-1.3-1s-0.9-0.3-1.5-0.3c-1,0-1.9,0.3-2.5,0.9c-0.6,0.6-1,1.4-1,2.4
			c0,0.9,0.3,1.7,0.9,2.3c0.6,0.6,1.4,0.9,2.5,0.9c1.3,0,2.2-0.4,2.9-1.3l2.2,1.5c-1.2,1.6-2.9,2.3-5.1,2.3c-2,0-3.5-0.6-4.6-1.7
			c-1.1-1.2-1.7-2.5-1.7-4.1c0-1.1,0.3-2.1,0.8-3c0.5-0.9,1.3-1.6,2.3-2.1c1-0.5,2-0.8,3.2-0.8c1.1,0,2.1,0.2,3,0.7
			C31.9,20.2,32.6,20.9,33.2,21.7z"
      />
    </g>
    <path
      class="st4"
      d="M28.5,5C16.9,4.4,7.3,13.6,7.3,25h4C11.3,15.9,19,8.5,28.2,9c8.2,0.4,14.9,7.1,15.3,15.3
		c0.4,8.9-6.4,16.3-15.1,16.8c-0.5,0-1,0.5-1,1v2c0,0.6,0.5,1,1,1c11-0.6,19.6-9.9,19-21.1C46.9,13.8,38.6,5.5,28.5,5z"
    />
  </g>
  <g class="st0">
    <path
      class="st6"
      d="M10,30.5l1.1-1.1l4.9-4.9c0.2-0.2,0.2-0.5,0-0.7l-1.4-1.4c-0.2-0.2-0.5-0.2-0.7,0L11.3,25h-4l-2.6-2.6
		c-0.2-0.2-0.5-0.2-0.7,0l-1.4,1.4c-0.2,0.2-0.2,0.5,0,0.7l4.9,4.9l1.1,1.1C9,30.9,9.7,30.9,10,30.5z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M33.2,21.7L30.8,23c-0.4-0.5-0.9-0.8-1.3-1s-0.9-0.3-1.5-0.3c-1,0-1.9,0.3-2.5,0.9c-0.6,0.6-1,1.4-1,2.4
			c0,0.9,0.3,1.7,0.9,2.3c0.6,0.6,1.4,0.9,2.5,0.9c1.3,0,2.2-0.4,2.9-1.3l2.2,1.5c-1.2,1.6-2.9,2.3-5.1,2.3c-2,0-3.5-0.6-4.6-1.7
			c-1.1-1.2-1.7-2.5-1.7-4.1c0-1.1,0.3-2.1,0.8-3c0.5-0.9,1.3-1.6,2.3-2.1c1-0.5,2-0.8,3.2-0.8c1.1,0,2.1,0.2,3,0.7
			C31.9,20.2,32.6,20.9,33.2,21.7z"
      />
    </g>
    <path
      class="st6"
      d="M28.5,5C16.9,4.4,7.3,13.6,7.3,25h4C11.3,15.9,19,8.5,28.2,9c8.2,0.4,14.9,7.1,15.3,15.3
		c0.4,8.9-6.4,16.3-15.1,16.8c-0.5,0-1,0.5-1,1v2c0,0.6,0.5,1,1,1c11-0.6,19.6-9.9,19-21.1C46.9,13.8,38.6,5.5,28.5,5z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M10,30.5l1.1-1.1l4.9-4.9c0.2-0.2,0.2-0.5,0-0.7l-1.4-1.4c-0.2-0.2-0.5-0.2-0.7,0L11.3,25h-4l-2.6-2.6
		c-0.2-0.2-0.5-0.2-0.7,0l-1.4,1.4c-0.2,0.2-0.2,0.5,0,0.7l4.9,4.9l1.1,1.1C9,30.9,9.7,30.9,10,30.5z"
    />
    <path
      class="st4"
      d="M28.5,5C16.9,4.4,7.3,13.6,7.3,25h4C11.3,15.9,19,8.5,28.2,9c8.2,0.4,14.9,7.1,15.3,15.3
		c0.4,8.9-6.4,16.3-15.1,16.8c-0.5,0-1,0.5-1,1v2c0,0.6,0.5,1,1,1c11-0.6,19.6-9.9,19-21.1C46.9,13.8,38.6,5.5,28.5,5z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M24.7,19.6v1.2c0.5-0.5,1.1-0.9,1.6-1.1c0.6-0.3,1.2-0.4,1.9-0.4c1.5,0,2.7,0.6,3.7,1.7
			c1,1.1,1.5,2.5,1.5,4.2c0,1.7-0.5,3.1-1.6,4.2c-1.1,1.1-2.3,1.7-3.7,1.7c-0.6,0-1.2-0.1-1.8-0.3c-0.6-0.2-1.1-0.6-1.7-1.1v5.3
			h-2.8V19.6H24.7z M27.6,21.9c-0.9,0-1.6,0.3-2.2,0.9s-0.9,1.4-0.9,2.4c0,1,0.3,1.8,0.9,2.4c0.6,0.6,1.3,0.9,2.2,0.9
			c0.9,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.4,0.9-2.4c0-1-0.3-1.7-0.9-2.4C29.2,22.2,28.5,21.9,27.6,21.9z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st6"
      d="M10,30.5l1.1-1.1l4.9-4.9c0.2-0.2,0.2-0.5,0-0.7l-1.4-1.4c-0.2-0.2-0.5-0.2-0.7,0L11.3,25h-4l-2.6-2.6
		c-0.2-0.2-0.5-0.2-0.7,0l-1.4,1.4c-0.2,0.2-0.2,0.5,0,0.7l4.9,4.9l1.1,1.1C9,30.9,9.7,30.9,10,30.5z"
    />
    <path
      class="st6"
      d="M28.5,5C16.9,4.4,7.3,13.6,7.3,25h4C11.3,15.9,19,8.5,28.2,9c8.2,0.4,14.9,7.1,15.3,15.3
		c0.4,8.9-6.4,16.3-15.1,16.8c-0.5,0-1,0.5-1,1v2c0,0.6,0.5,1,1,1c11-0.6,19.6-9.9,19-21.1C46.9,13.8,38.6,5.5,28.5,5z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M24.7,19.6v1.2c0.5-0.5,1.1-0.9,1.6-1.1c0.6-0.3,1.2-0.4,1.9-0.4c1.5,0,2.7,0.6,3.7,1.7
			c1,1.1,1.5,2.5,1.5,4.2c0,1.7-0.5,3.1-1.6,4.2c-1.1,1.1-2.3,1.7-3.7,1.7c-0.6,0-1.2-0.1-1.8-0.3c-0.6-0.2-1.1-0.6-1.7-1.1v5.3
			h-2.8V19.6H24.7z M27.6,21.9c-0.9,0-1.6,0.3-2.2,0.9s-0.9,1.4-0.9,2.4c0,1,0.3,1.8,0.9,2.4c0.6,0.6,1.3,0.9,2.2,0.9
			c0.9,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.4,0.9-2.4c0-1-0.3-1.7-0.9-2.4C29.2,22.2,28.5,21.9,27.6,21.9z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M6,47.5H3c-0.3,0-0.5-0.2-0.5-0.5V3c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5v44
		C6.5,47.3,6.3,47.5,6,47.5z"
    />
    <path
      class="st4"
      d="M2.5,47v-3c0-0.3,0.2-0.5,0.5-0.5h44c0.3,0,0.5,0.2,0.5,0.5v3c0,0.3-0.2,0.5-0.5,0.5H3
		C2.7,47.5,2.5,47.3,2.5,47z"
    />
    <path
      class="st4"
      d="M9.9,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V29.8c0-0.3-0.2-0.5-0.4-0.5H9.9c-0.2,0-0.4,0.2-0.4,0.5V40
		C9.5,40.3,9.7,40.5,9.9,40.5z"
    />
    <path
      class="st4"
      d="M14,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5v-3.2c0-0.3-0.2-0.5-0.4-0.5H14c-0.2,0-0.4,0.2-0.4,0.5V40
		C13.6,40.3,13.8,40.5,14,40.5z"
    />
    <path
      class="st4"
      d="M18.2,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V22.8c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C17.8,40.3,17.9,40.5,18.2,40.5z"
    />
    <path
      class="st4"
      d="M22.3,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V6c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5v34
		C21.9,40.3,22.1,40.5,22.3,40.5z"
    />
    <path
      class="st4"
      d="M26.4,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V12.8c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C26,40.3,26.2,40.5,26.4,40.5z"
    />
    <path
      class="st4"
      d="M30.5,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V27.8c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C30.1,40.3,30.3,40.5,30.5,40.5z"
    />
    <path
      class="st4"
      d="M34.6,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5v-7.2c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C34.2,40.3,34.4,40.5,34.6,40.5z"
    />
    <path
      class="st4"
      d="M38.8,40.5H40c0.2,0,0.4-0.2,0.4-0.5V17.8c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C38.4,40.3,38.6,40.5,38.8,40.5z"
    />
    <path
      class="st4"
      d="M42.9,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V27c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5v13
		C42.5,40.3,42.7,40.5,42.9,40.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st4"
      d="M22,31v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9C22.2,30.5,22,30.7,22,31
		z"
    />
    <path
      class="st7"
      d="M22,6v5c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9C22.2,5.5,22,5.7,22,6z"
    />
    <path
      class="st4"
      d="M34.5,6v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,5.5,34.5,5.7,34.5,6z"
    />
    <path
      class="st7"
      d="M22,14v14c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V14c0-0.3-0.2-0.5-0.5-0.5h-9
		C22.2,13.5,22,13.7,22,14z"
    />
    <path
      class="st7"
      d="M34.5,18v22c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V18c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,17.5,34.5,17.7,34.5,18z"
    />
    <path
      class="st7"
      d="M9.5,25v15c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V25c0-0.3-0.2-0.5-0.5-0.5h-9
		C9.7,24.5,9.5,24.7,9.5,25z"
    />
    <path
      class="st4"
      d="M9.5,6v16c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9C9.7,5.5,9.5,5.7,9.5,6z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st4"
      d="M22,31v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9C22.2,30.5,22,30.7,22,31
		z"
    />
    <path
      class="st7"
      d="M22,18.5v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C22.2,18,22,18.2,22,18.5z"
    />
    <path
      class="st4"
      d="M22,6v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9C22.2,5.5,22,5.7,22,6z"
    />
    <path
      class="st7"
      d="M9.5,31v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C9.7,30.5,9.5,30.7,9.5,31z"
    />
    <path
      class="st4"
      d="M9.5,18.5v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C9.7,18,9.5,18.2,9.5,18.5z"
    />
    <path
      class="st7"
      d="M9.5,6v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9C9.7,5.5,9.5,5.7,9.5,6z"
    />
    <path
      class="st4"
      d="M34.5,31v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,30.5,34.5,30.7,34.5,31z"
    />
    <path
      class="st7"
      d="M34.5,18.5v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,18,34.5,18.2,34.5,18.5z"
    />
    <path
      class="st7"
      d="M34.5,6v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,5.5,34.5,5.7,34.5,6z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v2.5V47c0,0.3,0.2,0.5,0.5,0.5h0.5
		c0,0,0,0,0,0h2c0,0,0,0,0,0H47c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <rect x="9.5" y="2.5" class="st6" width="38" height="38" />
    <polygon
      class="st7"
      points="9.5,40.5 9.5,14.8 19.2,11.8 30.2,17.5 39.7,9.5 47.5,13.1 47.5,40.5 	"
    />
    <polygon
      class="st4"
      points="47.5,22.7 47.5,40.5 9.5,40.5 9.5,30.3 14.6,25.9 25,32.7 34.9,25.9 41.6,28.2 	"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v2.5V47c0,0.3,0.2,0.5,0.5,0.5h0.5
		c0,0,0,0,0,0h2c0,0,0,0,0,0H47c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <polygon
      class="st6"
      points="9.5,40.5 9.5,13.7 13.9,10.7 21.4,12.7 33.5,6.6 42.2,8.6 47.5,6 47.5,40.5 	"
    />
    <polygon
      class="st7"
      points="9.5,40.5 9.5,20 21.9,21.5 28,14.5 37.7,17.6 47.5,10.7 47.5,40.5 	"
    />
    <polygon
      class="st4"
      points="47.5,25.6 47.5,40.5 9.5,40.5 9.5,30.2 17.4,28.8 26.2,31.8 34.6,24.7 41.5,28.2 	"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v2.5V47c0,0.3,0.2,0.5,0.5,0.5h0.5
		c0,0,0,0,0,0h2c0,0,0,0,0,0H47c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <polygon
      class="st6"
      points="9.5,40.5 9.5,24.2 13.4,21.3 26.3,25 37.9,13.8 47.5,11.9 47.5,40.5 	"
    />
    <polygon
      class="st8"
      points="47.5,15.1 47.5,40.5 9.5,40.5 9.5,27.9 16.1,25.5 23.3,13.7 30.9,10.7 40.1,21.8 	"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st4"
      d="M43.7,10.7L28.9,25.4c-0.2,0.2-0.5,0.2-0.7,0l-7.1-7.1c-0.2-0.2-0.5-0.2-0.7,0L9.6,29.2
		c-0.1,0.1-0.1,0.2-0.1,0.4v6.1c0,0.4,0.5,0.7,0.8,0.4l10.1-10.1c0.2-0.2,0.5-0.2,0.7,0l7.1,7.1c0.2,0.2,0.5,0.2,0.7,0l15.4-15.4
		c0.1-0.1,0.1-0.2,0.1-0.4v-6.1C44.5,10.6,44,10.4,43.7,10.7z"
    />
  </g>
  <g class="st0">
    <path class="st4" d="M26.5,2.5v19l13.9-13C36.7,5.1,31.8,2.9,26.5,2.5z" />
    <path
      class="st4"
      d="M23.7,25.7C23.7,25.7,23.7,25.7,23.7,25.7c-0.1-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1
		c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1V2.5C11.8,3.3,2.5,13.1,2.5,25c0,12.4,10.1,22.5,22.5,22.5
		c3.6,0,6.9-0.8,9.9-2.3L23.7,25.7z"
    />
    <path
      class="st4"
      d="M42.4,10.7L26.9,25.3l10.6,18.4c6-4,10-10.9,10-18.7C47.5,19.6,45.6,14.6,42.4,10.7z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M44,18.5H10c-0.3,0-0.5,0.2-0.5,0.5v8c0,0.3,0.2,0.5,0.5,0.5h34c0.3,0,0.5-0.2,0.5-0.5v-8
			C44.5,18.7,44.3,18.5,44,18.5z M42.5,25c0,0.3-0.2,0.5-0.5,0.5h-5.7c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5H42
			c0.3,0,0.5,0.2,0.5,0.5V25z"
      />
      <path
        class="st2"
        d="M44,31.5H10c-0.3,0-0.5,0.2-0.5,0.5v8c0,0.3,0.2,0.5,0.5,0.5h34c0.3,0,0.5-0.2,0.5-0.5v-8
			C44.5,31.7,44.3,31.5,44,31.5z M42.5,38c0,0.3-0.2,0.5-0.5,0.5H20.6c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5H42
			c0.3,0,0.5,0.2,0.5,0.5V38z"
      />
      <path
        class="st2"
        d="M44,5.5H10C9.7,5.5,9.5,5.7,9.5,6v8c0,0.3,0.2,0.5,0.5,0.5h34c0.3,0,0.5-0.2,0.5-0.5V6
			C44.5,5.7,44.3,5.5,44,5.5z M42.5,12c0,0.3-0.2,0.5-0.5,0.5H31.2c-0.3,0-0.5-0.2-0.5-0.5V8c0-0.3,0.2-0.5,0.5-0.5H42
			c0.3,0,0.5,0.2,0.5,0.5V12z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M22.5,6v34c0,0.3,0.2,0.5,0.5,0.5h8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-8
			C22.7,5.5,22.5,5.7,22.5,6z M29,7.5c0.3,0,0.5,0.2,0.5,0.5v5.7c0,0.3-0.2,0.5-0.5,0.5h-4c-0.3,0-0.5-0.2-0.5-0.5V8
			c0-0.3,0.2-0.5,0.5-0.5H29z"
      />
      <path
        class="st2"
        d="M35.5,6v34c0,0.3,0.2,0.5,0.5,0.5h8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-8
			C35.7,5.5,35.5,5.7,35.5,6z M42,7.5c0.3,0,0.5,0.2,0.5,0.5v21.4c0,0.3-0.2,0.5-0.5,0.5h-4c-0.3,0-0.5-0.2-0.5-0.5V8
			c0-0.3,0.2-0.5,0.5-0.5H42z"
      />
      <path
        class="st2"
        d="M9.5,6v34c0,0.3,0.2,0.5,0.5,0.5h8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-8C9.7,5.5,9.5,5.7,9.5,6z
			 M16,7.5c0.3,0,0.5,0.2,0.5,0.5v10.8c0,0.3-0.2,0.5-0.5,0.5h-4c-0.3,0-0.5-0.2-0.5-0.5V8c0-0.3,0.2-0.5,0.5-0.5H16z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st4"
      d="M44,18.5H10c-0.3,0-0.5,0.2-0.5,0.5v8c0,0.3,0.2,0.5,0.5,0.5h34c0.3,0,0.5-0.2,0.5-0.5v-8
		C44.5,18.7,44.3,18.5,44,18.5z M42.5,25c0,0.3-0.2,0.5-0.5,0.5H30c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5h12
		c0.3,0,0.5,0.2,0.5,0.5V25z"
    />
    <path
      class="st4"
      d="M34,31.5H10c-0.3,0-0.5,0.2-0.5,0.5v8c0,0.3,0.2,0.5,0.5,0.5h24c0.3,0,0.5-0.2,0.5-0.5v-8
		C34.5,31.7,34.3,31.5,34,31.5z M32.5,38c0,0.3-0.2,0.5-0.5,0.5H20c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5h12
		c0.3,0,0.5,0.2,0.5,0.5V38z"
    />
    <path
      class="st4"
      d="M27,5.5H10C9.7,5.5,9.5,5.7,9.5,6v8c0,0.3,0.2,0.5,0.5,0.5h17c0.3,0,0.5-0.2,0.5-0.5V6
		C27.5,5.7,27.3,5.5,27,5.5z M25.5,12c0,0.3-0.2,0.5-0.5,0.5h-4.5c-0.3,0-0.5-0.2-0.5-0.5V8c0-0.3,0.2-0.5,0.5-0.5H25
		c0.3,0,0.5,0.2,0.5,0.5V12z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M23,40.5h8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-8c-0.3,0-0.5,0.2-0.5,0.5v34
		C22.5,40.3,22.7,40.5,23,40.5z M24.5,8c0-0.3,0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5v12c0,0.3-0.2,0.5-0.5,0.5h-4
		c-0.3,0-0.5-0.2-0.5-0.5V8z"
    />
    <path
      class="st4"
      d="M36,40.5h8c0.3,0,0.5-0.2,0.5-0.5V16c0-0.3-0.2-0.5-0.5-0.5h-8c-0.3,0-0.5,0.2-0.5,0.5v24
		C35.5,40.3,35.7,40.5,36,40.5z M37.5,18c0-0.3,0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5v12c0,0.3-0.2,0.5-0.5,0.5h-4
		c-0.3,0-0.5-0.2-0.5-0.5V18z"
    />
    <path
      class="st4"
      d="M10,40.5h8c0.3,0,0.5-0.2,0.5-0.5V23c0-0.3-0.2-0.5-0.5-0.5h-8c-0.3,0-0.5,0.2-0.5,0.5v17
		C9.5,40.3,9.7,40.5,10,40.5z M11.5,25c0-0.3,0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5v4.5c0,0.3-0.2,0.5-0.5,0.5h-4
		c-0.3,0-0.5-0.2-0.5-0.5V25z"
    />
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <g class="st1">
      <g>
        <path
          class="st2"
          d="M39,23H9.5v-3H39c0.3,0,0.5,0.2,0.5,0.5v2C39.5,22.8,39.3,23,39,23z"
        />
        <path
          class="st2"
          d="M42,28H9.5v-3H42c0.3,0,0.5,0.2,0.5,0.5v2C42.5,27.8,42.3,28,42,28z"
        />
      </g>
      <g>
        <path
          class="st2"
          d="M32,35.5H9.5v-3H32c0.3,0,0.5,0.2,0.5,0.5v2C32.5,35.3,32.3,35.5,32,35.5z"
        />
        <path
          class="st2"
          d="M29,40.5H9.5v-3H29c0.3,0,0.5,0.2,0.5,0.5v2C29.5,40.3,29.3,40.5,29,40.5z"
        />
      </g>
      <g>
        <path
          class="st2"
          d="M25,10.5H9.5v-3H25c0.3,0,0.5,0.2,0.5,0.5v2C25.5,10.3,25.3,10.5,25,10.5z"
        />
        <path
          class="st2"
          d="M23,15.5H9.5v-3H23c0.3,0,0.5,0.2,0.5,0.5v2C23.5,15.3,23.3,15.5,23,15.5z"
        />
      </g>
    </g>
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M25,11v29.5h-3V11c0-0.3,0.2-0.5,0.5-0.5h2C24.8,10.5,25,10.7,25,11z"
      />
      <path
        class="st2"
        d="M30,8v32.5h-3V8c0-0.3,0.2-0.5,0.5-0.5h2C29.8,7.5,30,7.7,30,8z"
      />
    </g>
    <g class="st1">
      <path
        class="st2"
        d="M37.5,18v22.5h-3V18c0-0.3,0.2-0.5,0.5-0.5h2C37.3,17.5,37.5,17.7,37.5,18z"
      />
      <path
        class="st2"
        d="M42.5,21v19.5h-3V21c0-0.3,0.2-0.5,0.5-0.5h2C42.3,20.5,42.5,20.7,42.5,21z"
      />
    </g>
    <g class="st1">
      <path
        class="st2"
        d="M12.5,25v15.5h-3V25c0-0.3,0.2-0.5,0.5-0.5h2C12.3,24.5,12.5,24.7,12.5,25z"
      />
      <path
        class="st2"
        d="M17.5,27v13.5h-3V27c0-0.3,0.2-0.5,0.5-0.5h2C17.3,26.5,17.5,26.7,17.5,27z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st4"
      d="M27,14.5H10c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5h17c0.3,0,0.5,0.2,0.5,0.5v8
		C27.5,14.3,27.3,14.5,27,14.5z"
    />
    <path
      class="st4"
      d="M34,40.5H10c-0.3,0-0.5-0.2-0.5-0.5v-8c0-0.3,0.2-0.5,0.5-0.5h24c0.3,0,0.5,0.2,0.5,0.5v8
		C34.5,40.3,34.3,40.5,34,40.5z"
    />
    <path
      class="st4"
      d="M44,27.5H10c-0.3,0-0.5-0.2-0.5-0.5v-8c0-0.3,0.2-0.5,0.5-0.5h34c0.3,0,0.5,0.2,0.5,0.5v8
		C44.5,27.3,44.3,27.5,44,27.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st4"
      d="M18.5,23v17c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V23c0-0.3,0.2-0.5,0.5-0.5h8
		C18.3,22.5,18.5,22.7,18.5,23z"
    />
    <path
      class="st4"
      d="M44.5,16v24c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V16c0-0.3,0.2-0.5,0.5-0.5h8
		C44.3,15.5,44.5,15.7,44.5,16z"
    />
    <path
      class="st4"
      d="M31.5,6v34c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5h8
		C31.3,5.5,31.5,5.7,31.5,6z"
    />
  </g>
  <g class="st0">
    <path
      class="st9"
      d="M22.9,33.1c-1.2-0.7-2-2-2-3.5c0-2.3,1.8-4.1,4.1-4.1s4.1,1.8,4.1,4.1c0,1.5-0.8,2.8-2,3.5l16,9.9
		c2.8-3.7,4.4-8.4,4.4-13.4C47.5,17.1,37.4,7.1,25,7.1C12.6,7.1,2.5,17.1,2.5,29.6c0,5,1.6,9.7,4.4,13.4L22.9,33.1z"
    />
    <path
      class="st4"
      d="M19.3,32.5c-0.6-1.2-0.9-2.6-0.6-4.1c0.4-2.6,2.5-4.8,5.1-5.3c4.1-0.8,7.7,2.4,7.7,6.3c0,1.1-0.3,2.1-0.7,3
		c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c0.9-1.7,1.4-3.7,1.1-5.8c-0.6-4.3-4.1-7.7-8.4-8.1
		c-5.7-0.6-10.5,3.8-10.5,9.4c0,1.6,0.4,3.2,1.2,4.5c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1C19.3,33.1,19.4,32.8,19.3,32.5z"
    />
    <path
      class="st7"
      d="M14.7,35.4c-1.2-2.1-1.8-4.7-1.4-7.4c0.7-5.4,5.1-9.7,10.5-10.3C30.6,17,36.6,22.3,36.9,29
		c0,0.3,0.2,0.5,0.5,0.5l1.8,0c0.5,0,0.7-0.2,0.7-0.5c-0.3-8.1-7.2-14.6-15.5-14.3c-7.5,0.3-13.7,6.4-14.2,13.9
		c-0.2,3,0.6,5.9,1.9,8.3c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1C14.7,35.9,14.8,35.6,14.7,35.4z"
    />
    <path
      class="st4"
      d="M8.2,39.9l1.4-0.8l0.3-0.2c0.2-0.1,0.3-0.4,0.2-0.7c-2-3.4-2.9-7.5-2.1-11.9c1.3-7.3,7.3-13,14.7-13.9
		c7.2-0.9,13.6,2.6,17,8.1c0.1,0.2,0.4,0.3,0.7,0.2l1.7-1c0.2-0.1,0.3-0.5,0.2-0.7c-3.1-5.1-8.4-8.7-14.5-9.6
		c-12.5-1.7-23.1,8-23.1,20.1c0,3.7,1,7.2,2.8,10.2C7.6,40,8,40.1,8.2,39.9z"
    />
  </g>
  <g class="st0">
    <path
      class="st9"
      d="M25,31.8L43,43c2.8-3.8,4.5-8.4,4.5-13.5C47.5,17.1,37.4,7,25,7C12.6,7,2.5,17.1,2.5,29.5
		c0,5,1.7,9.7,4.5,13.5L25,31.8z"
    />
    <path
      class="st7"
      d="M14.7,35.3c-1.2-2.1-1.8-4.7-1.4-7.4c0.7-5.4,5.1-9.7,10.5-10.3c7.1-0.7,13.2,4.8,13.2,11.8
		c0,2.1-0.6,4.1-1.5,5.8c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c1.4-2.4,2.1-5.3,1.9-8.3
		c-0.5-7.5-6.7-13.6-14.2-13.9c-8.5-0.3-15.5,6.4-15.5,14.9c0,2.7,0.7,5.2,2,7.4c0.1,0.2,0.5,0.3,0.7,0.2l1.5-1
		C14.7,35.9,14.8,35.6,14.7,35.3z"
    />
    <path
      class="st4"
      d="M9.9,38.9c0.2-0.1,0.3-0.4,0.2-0.7C8.1,34.8,7.2,30.8,8,26.5c1.3-7.4,7.3-13.2,14.7-14.1
		c9.8-1.3,18.2,5.6,19.5,14.8c0,0.3,0.3,0.5,0.5,0.4l1.8-0.2c0.5,0,0.7-0.3,0.6-0.6C43.7,16.4,34.4,8.5,23.4,9.3
		c-10,0.8-18,8.9-18.7,18.9c-0.3,4.2,0.8,8.2,2.7,11.5C7.6,40,8,40.1,8.2,39.9L9.9,38.9z"
    />
    <path
      class="st4"
      d="M19.3,32.5c-0.6-1.2-0.9-2.6-0.7-4c0.4-2.7,2.5-4.8,5.2-5.3c1.7-0.3,3.4,0.1,4.7,0.9c0.2,0.1,0.5,0.1,0.7-0.1
		l1.2-1.6c0.2-0.2,0.1-0.6-0.1-0.7c-1.9-1.3-4.3-1.9-6.8-1.5c-3.8,0.6-6.9,3.6-7.7,7.4c-0.5,2.4-0.1,4.6,1,6.5
		c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1C19.3,33,19.4,32.7,19.3,32.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st9"
      d="M25,31.9L43,43c2.9-3.8,4.5-8.5,4.5-13.6C47.5,17,37.4,7,25,7C12.6,7,2.5,17,2.5,29.5c0,5.1,1.7,9.8,4.5,13.6
		L25,31.9z"
    />
    <path
      class="st7"
      d="M10.1,38.1C8.1,34.8,7.2,30.8,8,26.5c1.3-7.5,7.5-13.4,15.1-14.2c10.4-1.1,19.2,7,19.2,17.2
		c0,3.2-0.9,6.1-2.4,8.7c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c1.8-3.1,2.8-6.6,2.8-10.4
		C45.2,18.7,36.6,9.7,26,9.2C14.3,8.7,4.7,17.9,4.7,29.5c0,3.7,1,7.2,2.8,10.2C7.6,39.9,8,40,8.2,39.9l1.7-1.1
		C10.1,38.7,10.2,38.4,10.1,38.1z"
    />
    <path
      class="st7"
      d="M14.7,35.3c-1.2-2.1-1.8-4.7-1.4-7.4c0.7-5.4,5.1-9.7,10.5-10.3c7.1-0.7,13.2,4.8,13.2,11.8
		c0,2.1-0.6,4.1-1.5,5.8c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c1.4-2.4,2.1-5.3,1.9-8.3
		c-0.5-7.5-6.7-13.6-14.2-13.9c-8.5-0.3-15.5,6.4-15.5,14.9c0,2.7,0.7,5.2,2,7.4c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1
		C14.7,35.8,14.8,35.5,14.7,35.3z"
    />
    <path
      class="st7"
      d="M19.3,32.4c-0.6-1.2-0.9-2.6-0.6-4.1c0.4-2.6,2.5-4.8,5.1-5.3c4.1-0.8,7.7,2.4,7.7,6.3c0,1.1-0.3,2.1-0.7,3
		c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c0.9-1.7,1.4-3.7,1.1-5.8c-0.6-4.3-4.1-7.7-8.4-8.1
		c-5.7-0.6-10.5,3.8-10.5,9.4c0,1.6,0.4,3.2,1.2,4.5c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1C19.3,33,19.4,32.7,19.3,32.4z"
    />
    <g class="st1">
      <ellipse
        transform="matrix(0.9949 -0.1013 0.1013 0.9949 -2.8567 2.6842)"
        class="st2"
        cx="25"
        cy="29.5"
        rx="3"
        ry="3"
      />
      <path
        class="st2"
        d="M25.5,30l-1.1-1.1c-0.2-0.2-0.2-0.5,0-0.7l7-7c0.2-0.2,0.5-0.2,0.7,0l1.1,1.1c0.2,0.2,0.2,0.5,0,0.7l-7,7
			C26,30.2,25.7,30.2,25.5,30z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st9"
      d="M25,31.9L43,43c2.9-3.8,4.5-8.5,4.5-13.6C47.5,17,37.4,7,25,7C12.6,7,2.5,17,2.5,29.5c0,5.1,1.7,9.8,4.5,13.6
		L25,31.9z"
    />
    <path
      class="st7"
      d="M10.1,38.1C8.1,34.8,7.2,30.8,8,26.5c1.3-7.5,7.5-13.4,15.1-14.2c10.4-1.1,19.2,7,19.2,17.2
		c0,3.2-0.9,6.1-2.4,8.7c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c1.8-3.1,2.8-6.6,2.8-10.4
		C45.2,18.7,36.6,9.7,26,9.2C14.3,8.7,4.7,17.9,4.7,29.5c0,3.7,1,7.2,2.8,10.2C7.6,39.9,8,40,8.2,39.9l1.7-1.1
		C10.1,38.7,10.2,38.4,10.1,38.1z"
    />
    <path
      class="st7"
      d="M14.7,35.3c-1.2-2.1-1.8-4.7-1.4-7.4c0.7-5.4,5.1-9.7,10.5-10.3c7.1-0.7,13.2,4.8,13.2,11.8
		c0,2.1-0.6,4.1-1.5,5.8c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c1.4-2.4,2.1-5.3,1.9-8.3
		c-0.5-7.5-6.7-13.6-14.2-13.9c-8.5-0.3-15.5,6.4-15.5,14.9c0,2.7,0.7,5.2,2,7.4c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1
		C14.7,35.8,14.8,35.5,14.7,35.3z"
    />
    <path
      class="st7"
      d="M19.3,32.4c-0.6-1.2-0.9-2.6-0.6-4.1c0.4-2.6,2.5-4.8,5.1-5.3c4.1-0.8,7.7,2.4,7.7,6.3c0,1.1-0.3,2.1-0.7,3
		c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c0.9-1.7,1.4-3.7,1.1-5.8c-0.6-4.3-4.1-7.7-8.4-8.1
		c-5.7-0.6-10.5,3.8-10.5,9.4c0,1.6,0.4,3.2,1.2,4.5c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1C19.3,33,19.4,32.7,19.3,32.4z"
    />
    <ellipse
      transform="matrix(0.9949 -0.1013 0.1013 0.9949 -2.8567 2.6842)"
      class="st4"
      cx="25"
      cy="29.5"
      rx="1.4"
      ry="1.4"
    />
    <path
      class="st4"
      d="M26.5,31c0.7-0.7,1.8-3.7,2-4.7c0-0.2-0.1-0.4-0.3-0.3c-1,0.2-4,1.3-4.7,1.9c-0.8,0.8-0.8,2.2,0,3
		S25.7,31.8,26.5,31z"
    />
  </g>
  <g class="st0">
    <path
      class="st9"
      d="M25,31.9L43,43c2.9-3.8,4.5-8.5,4.5-13.6C47.5,17,37.4,7,25,7C12.6,7,2.5,17,2.5,29.5c0,5.1,1.7,9.8,4.5,13.6
		L25,31.9z"
    />
    <path
      class="st4"
      d="M10.1,38.1C8.1,34.8,7.2,30.8,8,26.5c1.3-7.5,7.5-13.4,15.1-14.2c10.4-1.1,19.2,7,19.2,17.2
		c0,3.2-0.9,6.1-2.4,8.7c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c1.8-3.1,2.8-6.6,2.8-10.4
		C45.2,18.7,36.6,9.7,26,9.2C14.3,8.7,4.7,17.9,4.7,29.5c0,3.7,1,7.2,2.8,10.2C7.6,39.9,8,40,8.2,39.9l1.7-1.1
		C10.1,38.7,10.2,38.4,10.1,38.1z"
    />
    <path
      class="st7"
      d="M14.7,35.3c-1.2-2.1-1.8-4.7-1.4-7.4c0.7-5.4,5.1-9.7,10.5-10.3c7.1-0.7,13.2,4.8,13.2,11.8
		c0,2.1-0.6,4.1-1.5,5.8c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c1.4-2.4,2.1-5.3,1.9-8.3
		c-0.5-7.5-6.7-13.6-14.2-13.9c-8.5-0.3-15.5,6.4-15.5,14.9c0,2.7,0.7,5.2,2,7.4c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1
		C14.7,35.8,14.8,35.5,14.7,35.3z"
    />
    <path
      class="st4"
      d="M19.3,32.4c-0.6-1.2-0.9-2.6-0.6-4.1c0.4-2.6,2.5-4.8,5.1-5.3c4.1-0.8,7.7,2.4,7.7,6.3c0,1.1-0.3,2.1-0.7,3
		c-0.1,0.2-0.1,0.5,0.2,0.7l1.7,1.1c0.2,0.1,0.6,0.1,0.7-0.2c0.9-1.7,1.4-3.7,1.1-5.8c-0.6-4.3-4.1-7.7-8.4-8.1
		c-5.7-0.6-10.5,3.8-10.5,9.4c0,1.6,0.4,3.2,1.2,4.5c0.1,0.2,0.5,0.3,0.7,0.2l1.7-1.1C19.3,33,19.4,32.7,19.3,32.4z"
    />
  </g>
  <g class="st0">
    <path
      class="st6"
      d="M47,29H3c-0.3,0-0.5-0.2-0.5-0.5v-7C2.5,21.2,2.7,21,3,21h44c0.3,0,0.5,0.2,0.5,0.5v7C47.5,28.8,47.3,29,47,29
		z"
    />
    <path
      class="st4"
      d="M31.5,23h-29v4H6h25.5c0.3,0,0.5-0.2,0.5-0.5v-3C32,23.2,31.8,23,31.5,23z"
    />
    <path
      class="st7"
      d="M39.4,20h-0.3C39,20,39,20,39,19.9v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C39.5,20,39.5,20,39.4,20z"
    />
    <path
      class="st7"
      d="M39.4,32h-0.3C39,32,39,32,39,31.9v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1L39.4,32
		C39.5,32,39.5,32,39.4,32z"
    />
    <path
      class="st7"
      d="M10.9,20h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C11,20,11,20,10.9,20z"
    />
    <path
      class="st7"
      d="M10.9,32h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C11,32,11,32,10.9,32z"
    />
    <path
      class="st7"
      d="M25.1,20h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C25.3,20,25.2,20,25.1,20z"
    />
    <path
      class="st7"
      d="M25.1,32h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C25.3,32,25.2,32,25.1,32z"
    />
  </g>
  <g class="st0">
    <path
      class="st10"
      d="M2.5,27H6h25.5c0.3,0,0.5-0.2,0.5-0.5v-3c0-0.3-0.2-0.5-0.5-0.5h-29"
    />
    <path
      class="st11"
      d="M47,29H3c-0.3,0-0.5-0.2-0.5-0.5v-7C2.5,21.2,2.7,21,3,21h44c0.3,0,0.5,0.2,0.5,0.5v7
		C47.5,28.8,47.3,29,47,29z"
    />
    <path
      class="st7"
      d="M25.1,20h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C25.3,20,25.2,20,25.1,20z"
    />
    <path
      class="st7"
      d="M25.1,32h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C25.3,32,25.2,32,25.1,32z"
    />
  </g>
  <g class="st0">
    <path
      class="st6"
      d="M47,25.5H3c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5h44c0.3,0,0.5,0.2,0.5,0.5v0
		C47.5,25.3,47.3,25.5,47,25.5z"
    />
    <path
      class="st4"
      d="M31.5,23.5h-29v3H6h25.5c0.3,0,0.5-0.2,0.5-0.5v-2C32,23.7,31.8,23.5,31.5,23.5z"
    />
    <path
      class="st7"
      d="M39.4,22.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1L39.4,22.5
		C39.5,22.5,39.5,22.5,39.4,22.5z"
    />
    <path
      class="st7"
      d="M39.4,29.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C39.5,29.5,39.5,29.5,39.4,29.5z"
    />
    <path
      class="st7"
      d="M10.9,22.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C11,22.5,11,22.5,10.9,22.5z"
    />
    <path
      class="st7"
      d="M10.9,29.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C11,29.5,11,29.5,10.9,29.5z"
    />
    <path
      class="st7"
      d="M25.1,21.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C25.3,21.5,25.2,21.5,25.1,21.5z"
    />
    <path
      class="st7"
      d="M25.1,30.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C25.3,30.5,25.2,30.5,25.1,30.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M47,25.5H3c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5h44c0.3,0,0.5,0.2,0.5,0.5v0
		C47.5,25.3,47.3,25.5,47,25.5z"
    />
    <path
      class="st6"
      d="M31.5,23.5h-29v3H6h25.5c0.3,0,0.5-0.2,0.5-0.5v-2C32,23.7,31.8,23.5,31.5,23.5z"
    />
    <path
      class="st7"
      d="M39.4,22.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1L39.4,22.5
		C39.5,22.5,39.5,22.5,39.4,22.5z"
    />
    <path
      class="st7"
      d="M39.4,29.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C39.5,29.5,39.5,29.5,39.4,29.5z"
    />
    <path
      class="st7"
      d="M10.9,22.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C11,22.5,11,22.5,10.9,22.5z"
    />
    <path
      class="st7"
      d="M10.9,29.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C11,29.5,11,29.5,10.9,29.5z"
    />
    <path
      class="st7"
      d="M25.1,21.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C25.3,21.5,25.2,21.5,25.1,21.5z"
    />
    <path
      class="st7"
      d="M25.1,30.5h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
		C25.3,30.5,25.2,30.5,25.1,30.5z"
    />
  </g>
  <g class="st0">
    <g class="st1">
      <path
        class="st12"
        d="M25.1,20h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
			C25.3,20,25.2,20,25.1,20z"
      />
      <path
        class="st12"
        d="M25.1,32h-0.3c-0.1,0-0.1,0-0.1-0.1v-1.8c0-0.1,0-0.1,0.1-0.1h0.3c0.1,0,0.1,0,0.1,0.1v1.8
			C25.3,32,25.2,32,25.1,32z"
      />
    </g>
    <path
      class="st6"
      d="M47,25.5H3c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5h44c0.3,0,0.5,0.2,0.5,0.5v0
		C47.5,25.3,47.3,25.5,47,25.5z"
    />
    <path
      class="st10"
      d="M2.5,26.5H6h25.5c0.3,0,0.5-0.2,0.5-0.5v-2c0-0.3-0.2-0.5-0.5-0.5h-29V26.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st4"
      d="M45.2,8.5H4.8c-1.2,0-2.2,1-2.2,2.2V37v2.2c0,1.2,1,2.2,2.2,2.2h40.5c1.2,0,2.2-1,2.2-2.2V37V10.7
		C47.5,9.5,46.5,8.5,45.2,8.5z M4,37V10.7C4,10.3,4.3,10,4.8,10h40.5c0.4,0,0.7,0.3,0.7,0.7V37H4z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M9,15.9h1.6l3.7,5.7v-5.7h1.6v8.6h-1.6l-3.7-5.7v5.7H9V15.9z"
      />
    </g>
    <path
      class="st6"
      d="M34,28.3v0.5c0,0.3-0.2,0.5-0.5,0.5h-25c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h25
		C33.8,27.8,34,28,34,28.3z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M20.7,16.9h-1.8c0.1-0.7,0.4-1.3,0.8-1.8c0.6-0.6,1.4-0.9,2.3-0.9c0.8,0,1.5,0.3,2.1,0.8s0.8,1.1,0.8,1.9
			c0,0.4-0.1,0.9-0.4,1.2s-0.6,0.7-1.1,0.9c0.6,0.2,1.1,0.5,1.4,1c0.3,0.5,0.5,1,0.5,1.6c0,0.9-0.3,1.7-1,2.3
			c-0.7,0.6-1.5,0.9-2.5,0.9c-1,0-1.8-0.3-2.4-0.9c-0.6-0.6-1-1.4-1-2.4h1.9c0.1,0.5,0.3,0.9,0.5,1.2c0.3,0.3,0.6,0.4,1.1,0.4
			c0.4,0,0.8-0.1,1.1-0.4s0.4-0.6,0.4-1.1c0-0.5-0.2-0.8-0.6-1.2s-1-0.5-1.7-0.5v-1.6c0.5,0,0.8-0.1,1-0.2c0.2-0.1,0.4-0.3,0.5-0.4
			s0.2-0.4,0.2-0.6c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.8-0.3c-0.3,0-0.5,0.1-0.7,0.2C20.9,16.4,20.7,16.7,20.7,16.9z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st6"
      d="M47.5,18.7v0.5c0,0.3-0.2,0.5-0.5,0.5h-7.8c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5H47
		C47.3,18.2,47.5,18.4,47.5,18.7z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M39.7,7.6h1.6l3.7,5.7V7.6h1.6v8.6H45l-3.7-5.7v5.7h-1.6V7.6z"
      />
    </g>
    <g class="st1">
      <path
        class="st13"
        d="M10.5,23c0.8-4,4.2-7.1,8.3-7.6V7.6C10.6,8.1,4,14.3,2.7,22.3L10.5,23z"
      />
      <path
        class="st12"
        d="M21.1,15.4c4.8,0.6,8.5,4.7,8.5,9.6c0,0.9-0.1,1.7-0.3,2.5l7.2,2.9c0.6-1.7,0.9-3.5,0.9-5.4
			c0-9.3-7.2-16.8-16.3-17.4V15.4z"
      />
      <path
        class="st2"
        d="M28.4,29.7c-1.7,3-4.8,5-8.5,5c-2.5,0-4.8-1-6.5-2.5l-5.9,5.1c3.2,3.2,7.6,5.2,12.4,5.2
			c6.9,0,12.9-4,15.7-9.9L28.4,29.7z"
      />
      <path
        class="st12"
        d="M11.9,30.4c-1-1.5-1.6-3.2-1.6-5.1l-7.8-0.7c0,0.1,0,0.3,0,0.4c0,3.9,1.3,7.6,3.5,10.5L11.9,30.4z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st6"
      d="M47.5,18.7v0.5c0,0.3-0.2,0.5-0.5,0.5h-7.8c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5H47
		C47.3,18.2,47.5,18.4,47.5,18.7z"
    />
    <g class="st1">
      <path
        class="st2"
        d="M39.7,7.6h1.6l3.7,5.7V7.6h1.6v8.6H45l-3.7-5.7v5.7h-1.6V7.6z"
      />
    </g>
    <g class="st1">
      <path
        class="st12"
        d="M10.5,23c0.8-4,4.2-7.1,8.3-7.6V7.6C10.6,8.1,4,14.3,2.7,22.3L10.5,23z"
      />
      <path
        class="st13"
        d="M21.1,15.4c4.8,0.6,8.5,4.7,8.5,9.6c0,0.9-0.1,1.7-0.3,2.5l7.2,2.9c0.6-1.7,0.9-3.5,0.9-5.4
			c0-9.3-7.2-16.8-16.3-17.4V15.4z"
      />
      <path
        class="st2"
        d="M28.4,29.7c-1.7,3-4.8,5-8.5,5c-2.5,0-4.8-1-6.5-2.5l-5.9,5.1c3.2,3.2,7.6,5.2,12.4,5.2
			c6.9,0,12.9-4,15.7-9.9L28.4,29.7z"
      />
      <path
        class="st13"
        d="M11.9,30.4c-1-1.5-1.6-3.2-1.6-5.1l-7.8-0.7c0,0.1,0,0.3,0,0.4c0,3.9,1.3,7.6,3.5,10.5L11.9,30.4z"
      />
    </g>
  </g>
  <g class="st0">
    <g class="st1">
      <path
        class="st2"
        d="M13.3,7c2.8,0.3,4.9,2.7,4.9,5.6c0,0.5-0.1,1-0.2,1.5l4.2,1.7c0.3-1,0.5-2.1,0.5-3.2c0-5.4-4.2-9.7-9.4-10.1
			V7z"
      />
      <path
        class="st13"
        d="M17.6,15.3c-1,1.7-2.8,2.9-4.9,2.9c-3.1,0-5.6-2.5-5.6-5.6C7,9.7,9.2,7.4,12,7V2.5C6.7,2.9,2.5,7.3,2.5,12.6
			c0,5.6,4.5,10.1,10.1,10.1c4,0,7.5-2.3,9.1-5.7L17.6,15.3z"
      />
    </g>
    <g class="st1">
      <path
        class="st2"
        d="M38,31.8c1.7,0.2,3.2,1.2,4.1,2.6l4.1-1.9c-1.6-2.9-4.7-5-8.2-5.2V31.8z"
      />
      <path
        class="st13"
        d="M46.8,33.7l-4.1,1.9c0.2,0.6,0.3,1.1,0.3,1.8c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6c0-2.9,2.2-5.2,4.9-5.6
			v-4.5c-5.3,0.3-9.4,4.7-9.4,10.1c0,5.6,4.5,10.1,10.1,10.1c5.6,0,10.1-4.5,10.1-10.1C47.5,36,47.2,34.8,46.8,33.7z"
      />
    </g>
    <g class="st1">
      <path
        class="st2"
        d="M38,2.5V7c2.8,0.3,4.9,2.7,4.9,5.6c0,3.1-2.5,5.6-5.6,5.6c-0.7,0-1.3-0.1-1.9-0.3l-2,4.1
			c1.2,0.5,2.5,0.8,3.9,0.8c5.6,0,10.1-4.5,10.1-10.1C47.5,7.3,43.3,2.9,38,2.5z"
      />
      <path
        class="st13"
        d="M34.3,17.3c-1.5-1-2.5-2.7-2.5-4.7c0-2.9,2.2-5.2,4.9-5.6V2.5c-5.3,0.3-9.4,4.7-9.4,10.1c0,3.7,2,7,5,8.8
			L34.3,17.3z"
      />
    </g>
    <g class="st1">
      <path
        class="st13"
        d="M7,36.7c0.3-2.6,2.3-4.6,4.9-4.9v-4.5c-5.1,0.3-9.1,4.4-9.4,9.4H7z"
      />
      <path
        class="st2"
        d="M13.3,27.3v4.5c2.8,0.3,4.9,2.7,4.9,5.6c0,3.1-2.5,5.6-5.6,5.6C9.7,43,7.4,40.8,7,38H2.5
			c0.3,5.3,4.7,9.4,10.1,9.4c5.6,0,10.1-4.5,10.1-10.1C22.7,32,18.6,27.6,13.3,27.3z"
      />
    </g>
  </g>
  <path
    class="st2"
    d="M45.2,7H4.8C3.5,7,2.5,8,2.5,9.2v5.2h0v26.3c0,1.2,1,2.2,2.2,2.2h40.5c1.2,0,2.2-1,2.2-2.2V14.5v-2.2v-3
	C47.5,8,46.5,7,45.2,7z M45.5,14.7V22h-28v-7.5h27.7C45.4,14.5,45.5,14.6,45.5,14.7z M17.5,24h28v7.5h-28V24z M15.5,31.5h-11V24h11
	V31.5z M4.8,14.5h10.8V22h-11v-7.3C4.5,14.6,4.6,14.5,4.8,14.5z M4.8,41c-0.1,0-0.2-0.1-0.2-0.2v-7.3h11V41H4.8z M45.2,41H17.5v-7.5
	h28v7.3C45.5,40.9,45.4,41,45.2,41z"
  />
  <g class="st0">
    <g class="st1">
      <rect x="17.5" y="26.7" class="st12" width="30" height="7.7" />
      <rect x="2.5" y="17" class="st12" width="13" height="7.7" />
      <path
        class="st12"
        d="M17.5,36.3V44H46c0.8,0,1.5-0.7,1.5-1.5v-6.2H17.5z"
      />
      <rect x="17.5" y="17" class="st12" width="30" height="7.7" />
      <rect x="2.5" y="26.7" class="st12" width="13" height="7.7" />
      <path
        class="st12"
        d="M15.5,36.3h-13v6.2C2.5,43.3,3.2,44,4,44h11.5V36.3z"
      />
    </g>
    <path
      class="st4"
      d="M47.5,15V8.3c0-1.2-1-2.2-2.2-2.2H4.7C3.5,6,2.5,7,2.5,8.3V15H47.5z"
    />
  </g>
  <g class="st0">
    <g class="st1">
      <rect x="17.5" y="26.7" class="st13" width="30" height="7.7" />
      <rect x="2.5" y="17" class="st13" width="13" height="7.7" />
      <path
        class="st13"
        d="M17.5,36.3V44H46c0.8,0,1.5-0.7,1.5-1.5v-6.2H17.5z"
      />
      <rect x="17.5" y="17" class="st13" width="30" height="7.7" />
      <rect x="2.5" y="26.7" class="st13" width="13" height="7.7" />
      <path
        class="st13"
        d="M15.5,36.3h-13v6.2C2.5,43.3,3.2,44,4,44h11.5V36.3z"
      />
    </g>
    <path
      class="st4"
      d="M47.5,15V8.3c0-1.2-1-2.2-2.2-2.2H4.7C3.5,6,2.5,7,2.5,8.3V15H47.5z"
    />
  </g>
</svg>
